import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Icon} from '../Icon/Icon';
import {GenericIconName} from '../Icon/IconName';

export const SizeBubble: FC<{
  size: {sizeId: number; label: string};
  onClick?: (id: number, isOutOfStock?: boolean) => void;
  active?: boolean;
  className?: string;
  isInlineSizeQuickViewEnabled?: boolean;
  showOutOfStock?: boolean;
  isOutOfStock?: boolean;
  showRecommendedSize?: boolean;
  recommendedSizeId?: number;
}> = ({
  active,
  className,
  onClick,
  size,
  showOutOfStock,
  showRecommendedSize,
  isOutOfStock,
  recommendedSizeId,
  isInlineSizeQuickViewEnabled,
}) => {
  const isRecommended =
    showRecommendedSize && recommendedSizeId === size.sizeId;

  const onBubbleClick = () => {
    if (!onClick) {
      return;
    }
    onClick(size.sizeId, isOutOfStock);
  };

  return (
    <Wrapper
      data-is-active={active}
      $active={Boolean(active)}
      as={onClick ? 'button' : 'div'}
      className={className}
      data-testid={`sizeBubble_${size.label}`}
      onClick={onBubbleClick}
      $isOutOfStock={isOutOfStock && showOutOfStock}
      $isRecommended={isRecommended}
      $isInlineSizeQuickViewAB={isInlineSizeQuickViewEnabled}
    >
      {showOutOfStock && isOutOfStock && (
        <Icon
          data-testid={'sizeBubbleOutOfStockIcon'}
          asset={GenericIconName.Mail}
          size={'XS'}
        />
      )}
      {isRecommended && (
        <Icon
          data-testid={'sizeBubbleRecommendedIcon'}
          asset={GenericIconName.Size}
          size={'XS'}
        />
      )}
      {size.label}
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  $active: boolean;
  $isOutOfStock?: boolean;
  $isRecommended?: boolean;
  $isInlineSizeQuickViewAB?: boolean;
}>`
  box-sizing: border-box;
  ${props =>
    props.$isInlineSizeQuickViewAB
      ? css`
          padding: 5px 12px;
          height: 26px;
          font-size: ${FONT_SIZES.px12};
          font-weight: ${FONT_WEIGHTS.mediumBold};
        `
      : css`
          height: 2rem;
          padding: 0 0.9375rem;
          font-size: ${FONT_SIZES.px13};
          font-weight: ${FONT_WEIGHTS.bold};
        `}

  border: ${({$active}) =>
    $active ? `1px solid ${COLORS.Black}` : `1px solid transparent`};
  background-color: ${({$active, $isRecommended}) => {
    if ($isRecommended) {
      return '#6ee5b1';
    }
    return $active ? 'transparent' : COLORS.Grey4;
  }};
  border-radius: 1rem;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  gap: 4px;

  ${props => (props.$isOutOfStock ? 'opacity:0.5;' : '')}
`;
